import React from 'react'

const WhyUs = () => {
    return (
        <div className='container-fluid p-5 text-center ' style={{backgroundColor: '#fff'}}>
            <div className='row'>
                <div className='col-3'>
                    <h1><b>18K</b></h1>
                    <p>Happy Customers</p>
                </div>
                <div className='col-3'>
                    <h1><b>150K</b></h1>
                    <p>Monthly Visitors</p>
                </div>
                <div className='col-3'>
                    <h1><b>5+</b></h1>
                    <p>Years of Excellence</p>
                </div>
                <div className='col-3'>
                    <h1><b>100+</b></h1>
                    <p>Top Products</p>
                </div>
            </div>
        </div>
    )
}

export default WhyUs